import { Routes, Route } from "react-router-dom";
import HomePage from "./components/homepage/HomePage";
import SigninPage from "./components/pages/SignInPage";
import OTPVerification from "./components/pages/OTPVerification";
import { SignUpage } from "./components/pages/SignUpage";
import Dashboard from "./components/pages/Dashboard";
import Navbar from "./components/homepage/Navbar";
import Footer from "./components/homepage/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<SignUpage />} />
        <Route path="/signin" element={<SigninPage />} />
        <Route path="/verification" element={<OTPVerification />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
